import { selectProcedureTypeById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { procedureTypeDetailViewLayoutHandle } from "src/views/ProcedureTypeDetailView/constants"
import { ProcedureTypeDetailView } from "src/views/ProcedureTypeDetailView/ProcedureTypeDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/$procedureTypeId",
)({
	component: ProcedureTypeDetailView,
	staticData: procedureTypeDetailViewLayoutHandle,
	loader: ({ params }) => {
		const procedureType = selectProcedureTypeById(params.procedureTypeId)(appStore.getState())
		if (!procedureType) throw notFound()
	},
})
